import LegalDocumentPage from "./LegalDocumentPage"

export default function DataProtectionPage() {
    return (
        <LegalDocumentPage
            title="Data Protection"
            subtitle="How HomeIndex supports GDPR-style requests and responsible handling of personal data."
            canonicalPath="/data-protection"
            sections={[
                {
                    title: "Controller and support",
                    paragraphs: [
                        "HomeIndex is the product-facing controller for the personal data collected through the website and support channels.",
                        "If you have questions about data handling, use the contact link in the footer to reach us.",
                    ],
                },
                {
                    title: "User rights",
                    paragraphs: [
                        "You may have rights to access, correct, delete, or restrict the processing of your personal data, subject to legal and operational limits.",
                        "If you want to exercise a right, contact us with enough detail for us to identify the relevant account, request, or transaction.",
                    ],
                },
                {
                    title: "Data minimisation",
                    paragraphs: [
                        "HomeIndex aims to collect only what is needed to provide the service, process payments, keep accounts secure, and improve the product when you consent to analytics.",
                        "Where practical, optional analytics and marketing tools stay off until you opt in.",
                    ],
                },
                {
                    title: "Retention and sharing",
                    paragraphs: [
                        "We keep data only as long as needed for the service, legal obligations, dispute handling, and analytics or business records where permitted.",
                        "Some product functionality depends on external providers such as Google, Stripe, OpenStreetMap, and our cloud infrastructure.",
                    ],
                },
            ]}
        />
    )
}
